import { ChipsInput } from '@prismamedia/one-components';
import { FC } from 'react';
import { BrandKey } from '../../../../../../__generated__/queries-web';
import {
  getTags,
  useGetTags,
} from '../../../../../../apollo/queries/tags.recipe.graphql';

interface TagsSelectProps {
  brandKey: BrandKey;
  disabled?: boolean;
  label: string;
  onChange: (tags: string[]) => void;
  value?: string[];
}

export const RecipeTagsSelect: FC<TagsSelectProps> = ({
  value: id_in = [],
  onChange,
  brandKey,
  ...rest
}) => {
  const { data } = useGetTags({ id_in });
  const value = data?.tags.map(({ id, title }) => ({ id, label: title }));

  return (
    <ChipsInput
      autocomplete={{
        fetchList: getTags(id_in),
        mandatoryInput: true,
      }}
      onChange={(items) => onChange(items.map(({ id }) => id))}
      value={value || []}
      {...rest}
    />
  );
};
